import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=6ce5f6ba"
import script from "./FormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormView.vue?vue&type=style&index=0&id=6ce5f6ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports